import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Memoized Stripe.js loader, keyed by publishable key.
 *
 * The portal has no `VITE_STRIPE_*` env — the publishable key is returned by
 * the backend's `/me/payment-methods/setup-intent` response so Stripe.js
 * always matches whatever mode (test/live) the backend SetupIntent was minted
 * in. We cache the promise per key so repeated Elements mounts don't re-fetch
 * the Stripe script.
 */
const cache = new Map<string, Promise<Stripe | null>>();

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  let p = cache.get(publishableKey);
  if (!p) {
    p = loadStripe(publishableKey);
    cache.set(publishableKey, p);
  }
  return p;
}
